import React, { useState, useEffect } from "react";

import img1 from "../data/1 number.jpg";
import img2 from "../data/2 number.jpg";
import img3 from "../data/3 number.jpg";
import img4 from "../data/4 number.jpg";
import img5 from "../data/5 number.jpg";
import img6 from "../data/6 number.jpg";

const images = [img1, img2, img3, img4, img5, img6];

const Products = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="bg-black">
      <div className="text-red-800  text-[30px] font-semibold leading-[30px]" >
        Party Hard and Keep the Vibe Alive
      </div>

      <div className="w-full pt-4 place-items-center">
        <button onClick={prevSlide}>◀️</button>
        <img src={images[currentIndex]} alt="slider" className="w-full lg:w-[400px] lg:h-[400px] " />
        <button onClick={nextSlide}>▶️</button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 justify-center items-center p-8">
        <div className="p-4 rounded-tr-3xl rounded-bl-3xl bg-neutral-950">
          <p className="bg-red-800 rounded-tr-3xl rounded-bl-3xl font-bold p-2 text-white">Taurine</p>
          <p className="text-red-800 font-bold">355 Mg</p>
        </div>
        <div className="p-4 rounded-tr-3xl rounded-bl-3xl  bg-neutral-950">
          <p className="bg-red-800 rounded-tr-3xl rounded-bl-3xl font-bold p-2 text-white">Niacin</p>
          <p className="text-red-800 font-bold">2.2 Mg</p>
        </div>
        <div className="p-4 rounded-tr-3xl rounded-bl-3xl bg-neutral-950">
          <p className="bg-red-800 rounded-tr-3xl rounded-bl-3xl font-bold p-2 text-white">Vitamins</p>
          <p className="text-red-800 font-bold">0.66 Mg</p>
        </div>
      </div>
    </div>
  );
};

export default Products;